/**
 * Product Customization Manager - VERSÃO DEFINITIVA
 * Gerencia a exibição/ocultação do campo de personalização
 * Funciona com inputs que usam o atributo "form"
 */

class ProductCustomizationManager {
  constructor() {
    this.customizationContainers = new Map();
    this.customizeInputs = new Map();
    this.init();
  }

  init() {
    console.log('[Customization] Script iniciado');
    
    // Aguardar o DOM estar completamente carregado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupCustomization());
    } else {
      this.setupCustomization();
    }

    // Observar mudanças dinâmicas
    this.observePageChanges();
  }

  setupCustomization() {
    console.log('[Customization] Iniciando setup...');
    
    // Encontrar todos os containers de customização
    const containers = document.querySelectorAll('[id^="customization-container-"]');
    console.log(`[Customization] Encontrados ${containers.length} containers`);
    
    containers.forEach((container) => {
      const sectionId = this.extractSectionId(container.id);
      this.customizationContainers.set(sectionId, container);
      this.setupForSection(sectionId);
    });
  }

  setupForSection(sectionId) {
    console.log(`[Customization] Setup para seção: ${sectionId}`);
    
    const container = this.customizationContainers.get(sectionId);
    if (!container) {
      console.warn(`[Customization] Container não encontrado para ${sectionId}`);
      return;
    }

    // Construir o ID do formulário esperado
    const formId = `ProductForm-${sectionId}`;
    console.log(`[Customization] Procurando inputs com form="${formId}"`);

    // Encontrar os radio buttons de "Customize" usando o atributo form
    const customizeInputs = document.querySelectorAll(
      `input[form="${formId}"][name*="Customize"]`
    );
    
    if (!customizeInputs || customizeInputs.length === 0) {
      console.warn(`[Customization] Inputs de customize não encontrados com form="${formId}"`);
      
      // Fallback: procurar por qualquer input com "Customize" no name
      const fallbackInputs = document.querySelectorAll('input[name*="Customize"]');
      if (fallbackInputs.length > 0) {
        console.log(`[Customization] Usando fallback: encontrados ${fallbackInputs.length} inputs`);
        this.setupInputListeners(sectionId, fallbackInputs);
      }
      return;
    }

    console.log(`[Customization] Encontrados ${customizeInputs.length} radio buttons de customize`);
    this.setupInputListeners(sectionId, customizeInputs);
  }

  setupInputListeners(sectionId, customizeInputs) {
    this.customizeInputs.set(sectionId, customizeInputs);

    // Listener para mudanças em cada input
    customizeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        console.log(`[Customization] Mudança detectada: ${input.value}`);
        this.handleCustomizeChange(sectionId);
      });
    });

    // Verificar estado inicial
    this.handleCustomizeChange(sectionId);

    // Listener para submit do formulário
    this.setupFormSubmitListener(sectionId, customizeInputs);

    // Setup de contadores de caracteres
    this.setupCharCounters(sectionId);
    
    console.log(`[Customization] Setup concluído para ${sectionId}`);
  }

  setupFormSubmitListener(sectionId, customizeInputs) {
    // Encontrar o formulário usando o atributo form do input
    if (customizeInputs.length === 0) return;
    
    const formId = customizeInputs[0].getAttribute('form');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) {
      console.warn(`[Customization] Formulário com ID "${formId}" não encontrado`);
      return;
    }

    form.addEventListener('submit', (e) => {
      this.handleFormSubmit(e, sectionId);
    });

    console.log(`[Customization] Listener de submit configurado para ${formId}`);
  }

  handleCustomizeChange(sectionId) {
    const container = this.customizationContainers.get(sectionId);
    const customizeInputs = this.customizeInputs.get(sectionId);
    
    if (!container || !customizeInputs) return;

    // Verificar qual input está selecionado
    let isCustomizeSelected = false;

    customizeInputs.forEach((input) => {
      if (input.checked && input.value === 'Customize') {
        isCustomizeSelected = true;
        console.log(`[Customization] "Customize" está SELECIONADO`);
      }
    });

    if (isCustomizeSelected) {
      this.showCustomization(container);
    } else {
      this.hideCustomization(container);
    }
  }

  showCustomization(container) {
    if (container.classList.contains('hidden')) {
      container.classList.remove('hidden');
      console.log('[Customization] Campo mostrado');
    }
  }

  hideCustomization(container) {
    if (!container.classList.contains('hidden')) {
      container.classList.add('hidden');
      console.log('[Customization] Campo ocultado');
    }
  }

  setupCharCounters(sectionId) {
    const nameInput = document.querySelector(`#customization-name-${sectionId}`);
    
    if (nameInput) {
      const updateCounter = () => {
        const counter = nameInput.parentElement.querySelector('.customization-char-count');
        if (counter) {
          counter.textContent = `${nameInput.value.length}/12`;
        }
      };

      nameInput.addEventListener('input', updateCounter);
      nameInput.addEventListener('change', updateCounter);
      updateCounter(); // Initial count
      
      console.log('[Customization] Contador de caracteres configurado');
    }
  }

  handleFormSubmit(event, sectionId) {
    const form = event.target;
    if (!form.action.includes('/cart/add')) return;

    const nameInput = document.querySelector(`#customization-name-${sectionId}`);
    const numberInput = document.querySelector(`#customization-number-${sectionId}`);

    if (!nameInput || !numberInput) return;

    const nameValue = nameInput.value.trim();
    const numberValue = numberInput.value.trim();

    // Se ambos estão vazios, não fazer nada
    if (!nameValue && !numberValue) {
      console.log('[Customization] Ambos campos vazios, não enviando dados');
      return;
    }

    // Criar inputs hidden para garantir que os dados sejam enviados
    const createHiddenInput = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.value = value;
      return input;
    };

    // Os inputs visíveis já usam name="properties[Name]"/"properties[Number]" no Liquid
    // (snippets/product-customization.liquid) — não precisa injetar hidden duplicando.
    // Limpamos hidden legados (de sessões anteriores em pt-BR) pra não duplicar no carrinho.
    form.querySelectorAll('input[type="hidden"][name^="properties["]').forEach((input) => {
      if (['properties[Nome]', 'properties[Número]', 'properties[Name]', 'properties[Number]'].includes(input.name)) {
        input.remove();
      }
    });

    console.log(`[Customization] Formulário enviado com: Nome="${nameValue}", Número="${numberValue}"`);
  }

  observePageChanges() {
    // Observar mudanças no DOM para detectar atualizações dinâmicas
    const observer = new MutationObserver(() => {
      const containers = document.querySelectorAll('[id^="customization-container-"]');
      containers.forEach((container) => {
        const sectionId = this.extractSectionId(container.id);
        if (!this.customizationContainers.has(sectionId)) {
          console.log(`[Customization] Nova seção detectada: ${sectionId}`);
          this.customizationContainers.set(sectionId, container);
          this.setupForSection(sectionId);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  extractSectionId(containerId) {
    // Extrai o ID da seção do container ID
    // Ex: "customization-container-abc123" -> "abc123"
    return containerId.replace('customization-container-', '');
  }
}

// Inicializar quando o script carregar
console.log('[Customization] Script carregado');
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.productCustomizationManager = new ProductCustomizationManager();
  });
} else {
  window.productCustomizationManager = new ProductCustomizationManager();
}
